/**
 * チーム絞り込みプルダウンの選択肢カタログ（表示順・表示名）の SSOT。
 *
 * KPI / 信頼性 / エンジニアボード / バグ評価 / QA責任評価 の 5 画面はいずれも同じ
 * 「チーム」プルダウンを出すが、従来は 5 箇所それぞれがリテラル配列を持っていたため
 * 実際にズレていた（バグ評価だけ ACE QA team が欠落、ラベルが `ACE airCloset` と
 * `ACE airCloset team` で不一致、並び順も不揃い）。入口ごとに選択肢を書き写さない
 * （CLAUDE.md「上限や選択肢の値を入口に写さない」）ため、ここを唯一の正本とする。
 *
 * `KpiTeam` を値として持つので、`KpiTeam` にチームが増えて本カタログに足し忘れると
 * `TEAM_OPTION_VALUES` の網羅チェックがコンパイルで落ちる。
 *
 * PMO は「チームのスコープ」ではなくチーム横断の専用ビューで KPI 画面にしか無いため、
 * このカタログには含めない（KPI 画面側で末尾に足す）。SRE も KPI 画面の方針に合わせて
 * 含めない（`getTeamFilter('sre')` 自体は履歴参照のため残っている）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business チーム絞り込みプルダウンの選択肢（表示順・表示名）の SSOT
 * @graph-connects none
 */
/**
 * チーム絞り込みの選択肢。親（PDG / ACE）の直後にその子チームを並べる。
 *
 * PDG TE の 2 サブチーム（Growth / Experience）は `team_name` を持たず nick_name で
 * 割るため、合計は PDG TE と一致しない（どちらにも属さない TE メンバーがいる）。
 * @graph-connects none
 */
export const TEAM_OPTIONS = [
    { value: 'all', label: '全体' },
    { value: 'pdg', label: 'PDG' },
    { value: 'tet', label: 'PDG TE' },
    { value: 'growth', label: 'PDG TE Growth' },
    { value: 'experience', label: 'PDG TE Experience' },
    { value: 'ace', label: 'ACE' },
    { value: 'aircloset', label: 'ACE airCloset team' },
    { value: 'platform', label: 'ACE Platform team' },
    { value: 'mall', label: 'ACE Mall team' },
    { value: 'qa', label: 'ACE QA team' },
];
/**
 * `TEAM_OPTIONS` の value 一覧。プルダウン以外（検索パラメータの検証等）で使う。
 * @graph-connects none
 */
export const TEAM_OPTION_VALUES = TEAM_OPTIONS.map((o) => o.value);
/**
 * チーム識別子を表示名に変換する。カタログに無い値（`sre` / `pmo` 等）はそのまま返す。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business チーム識別子をプルダウンと同じ表示名に変換する
 * @graph-connects none
 */
export function getTeamOptionLabel(team) {
    return TEAM_OPTIONS.find((o) => o.value === team)?.label ?? team;
}
//# sourceMappingURL=team-options.js.map